import styled from "styled-components";
import { PersonalInformationContainer } from "../../../health/forms/personal-information/personal-information-style";

export const HealthForeignersInformationContainer = styled(PersonalInformationContainer)``;
